import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8cad1844.js';
import './chunk-590a6902.js';
import './chunk-ea9bc877.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { I as Input } from './chunk-113685dc.js';
export { I as BInput } from './chunk-113685dc.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Input);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/input.js
// module id = a5T5
// module chunks = 0 1